import { GET_JOB_HOURS, SET_JOB_HOURS_LOADING } from "../../../../enums/Request/request.types";

export const getJobHoursAction = (data) => {
    return {
        type: GET_JOB_HOURS,
        payload: data,
    };
};

export const setJobHoursLoadingAction = (isLoading) => {
    return {
        type: SET_JOB_HOURS_LOADING,
        payload: isLoading,
    };
};